import deepmerge from 'deepmerge';
import { random } from './number';

export function compose(...rest: any[]) {
    return (x: any) => rest.reduceRight((y, f) => f(y), x);
}

export function createArray(length: number, mapping?: (index:number) => any) {
    return new Array(length).fill(0).map((_, index) => mapping ? mapping(index) : index);
}

export function createGrid<T>(wide: number, high: number, value: T): T[][] {
    return createArray(wide, () => new Array(high).fill(value));
}

export function getLast<T>(items: T[]) {
    return items[items.length - 1];
}

export function getRandom<T>(items: T[]) {
    const index = random(0, items.length - 1, true);
    return items[index];
}

export function getUrl(path: string) {
    if (path.startsWith('http')) {
        return path;
    }
    return `${process.env.NEXT_CONFIG_BASE_PATH || ''}${path}`;
}

export function getKromaticSiteOriginForHost(hostname?: string | null): string | null {
    const host = (hostname || '').toLowerCase();

    if (host === 'staging.kromatic.com') {
        return 'https://staging.kromatic.com';
    }

    if (host === 'kromatic.com' || host === 'www.kromatic.com') {
        return 'https://kromatic.com';
    }

    return null;
}

export function resolveKromaticSiteUrl(url: string, runtimeHostname?: string): string {
    if (!url) {
        return url;
    }

    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return url;
    }

    const host = parsed.hostname.toLowerCase();
    const isKnownKromaticHost =
        host === 'kromatic.com' || host === 'www.kromatic.com' || host === 'staging.kromatic.com';
    if (!isKnownKromaticHost) {
        return url;
    }

    const resolvedOrigin = getKromaticSiteOriginForHost(
        runtimeHostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
    );
    if (!resolvedOrigin) {
        return url;
    }

    const target = new URL(resolvedOrigin);
    parsed.protocol = target.protocol;
    parsed.host = target.host;
    return parsed.toString();
}

export function merge<T>(x: T, y: any) {
    return deepmerge<T>(x, y, {
        arrayMerge: (_destination, source) => source,
    });
}

export function validateEmail(email: string) {
    return /^.+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.exec(email);
}
